import Vue from 'vue';

const showError = (context, response) => {
  context.abAccount.errorMsg = response.msg;
  toastr.error(response.msg);
};

const success = (context, response) => {
  if (response.response_code) {
    switch (response.response_code) {
      case 'HARD_BLOCK':
        context.airbnbActiveStep = 1;
        return;
      case 'AIRLOCK_VERIFICATION':
        context.airbnbActiveStep = 2;
        context.airbnbConnectUpdate();
        return;
      case 'AUTHENTICATED':
        const account = JSON.parse(response.account);
        context.airbnbAccount = account;
        context.airbnbActiveStep = 5;
        context.airbnbUserId = account.id;
        context.airbnbConnectUpdate();
        return;
      case 'MFA_VERIFICATION':
        context.airbnbActiveStep = 3;
        context.abAccount.tempId = response.airbnb_temp_user_id;
        context.abAccount.mfaOptions = response.mfa_options;
        return;
    }
  }
  showError(context, response);
};

export default (context) => {
  context.airbnbActiveLoading = true;
  return Vue.$http.post('/airbnb/connect', {
    username: context.abAccount.airbnbUsername,
    password: context.abAccount.airbnbPassword,
    after_airlock: context.abAccount.afterAirlock,
  })
    .then(response => {
      if (response && response.status === 200) {
        success(context, response.data);
      } else {
        showError(context, response.data);
      }
    })
    .catch(error => {
      showError(context, error.response.data);
    })
    .finally(() => {
      context.abAccount.afterAirlock = false;
      context.airbnbActiveLoading = false;
    });
}



// WEBPACK FOOTER //
// ./src/app/services/airbnb/connect.js